// @flow

/**
 * Converts a pixel string into a number.
 * @param {String} pxString - A string to convert into a number.
 */
export const pxToNumber = (pxString: string) => +pxString.replace('px', '');
